import { Collection } from 'core/model/Collection';
import BoardModel from './BoardModel';

class BoardCollection extends Collection<BoardModel> {
  get url() {
    return '/api/ui/boards';
  }

  get model() {
    return BoardModel;
  }
}

export default BoardCollection;
